import { Pill } from "@/ui";
import { ENTITY_STATUS, type EntityStatus } from "./master";

/** 主数据实体启用与停用的标签。 */
export function EntityStatusPill({ status }: { status: EntityStatus }) {
  return <Pill tone={status === "active" ? "success" : "neutral"}>{ENTITY_STATUS[status]}</Pill>;
}
